import { render, staticRenderFns } from "./stuParent.vue?vue&type=template&id=2727653f&scoped=true"
import script from "./stuParent.vue?vue&type=script&lang=js"
export * from "./stuParent.vue?vue&type=script&lang=js"
import style0 from "./stuParent.vue?vue&type=style&index=0&id=2727653f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727653f",
  null
  
)

export default component.exports